import {
  Button,
  Card,
  Inline,
  Link,
  Skeleton,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import type { Track } from '@omnipresentgroup/mixpanel';

import { useUser, useUserMutation } from '../../hooks';

export const PrivacyPolicyCard = ({ track }: { track: Track }) => {
  const { data: opUser, isLoading } = useUser();

  const { mutate: acceptPrivacyPolicy } = useUserMutation();

  const isDataAvailable = !isLoading && opUser;

  return (
    <Card p="32">
      <Stack gap="32">
        <Stack gap="16">
          <Typography as="h2" size="24" weight="bold" hideParagraphSpacing>
            Privacy policy
          </Typography>
          <Typography as="span" size="16">
            Before we get started, we need you to agree to the collection of
            some of your personal information as set out in the privacy policy.
          </Typography>
          <Typography as="span" size="16">
            By clicking “Agree and get started” you agree to have read,
            understood and accept the &nbsp;
            <Inline
              css={{ display: 'inline' }}
              onClick={() => {
                track('View Privacy Policy Clicked');
              }}
            >
              <Link
                size="16"
                icon="ExternalLink"
                to="https://omnipresent-assets.s3.eu-west-2.amazonaws.com/Omnipresent+-+GDPR+Privacy+Policy.docx.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                privacy policy.
              </Link>
            </Inline>
          </Typography>
        </Stack>
        <Inline justify="end">
          {isDataAvailable ? (
            <Button
              onClick={() => {
                track('Accept Privacy Policy Clicked');
                acceptPrivacyPolicy(
                  {
                    id: opUser.authId,
                    payload: {
                      seenPrivacyPolicy: new Date().toISOString(),
                    },
                  },
                  {
                    onSuccess: () => {
                      window.location.reload();
                    },
                  },
                );
              }}
            >
              Agree and get started
            </Button>
          ) : (
            <Skeleton width={170} height={40} />
          )}
        </Inline>
      </Stack>
    </Card>
  );
};
